export default "__VITE_ASSET__53b2589b__"